import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _Absenteeism, _AnnotationReport, _Comparison } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PrintJson } from "../../../theme/Component/PrintJson";


export const Comparison = () => {

    const Comparison = useDataBean(_Comparison);

    const single = Singleton.getInstance();
    const [state, setstate] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [state])


    // const getLista = () => {

    //     Comparison.instance.getComparisonCatalogPorPropiedades({ State: 1}, null).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 setLista(resp)
    //             }

    //         }
    //     )

    // }


    const getLista = () => {

        Comparison.instance.getComparisonCatalogByPropertiesRender({ State: state }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        Comparison.setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        Comparison.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAdd({ ...modalAdd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        Comparison.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDComparison', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo Comparendo', property: 'TypeComparisonName', visible: true },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },
        { title: 'Fecha Comparendo', property: 'ComparisonDate', visible: true },
        { title: 'Entidad que impone comparendo', property: 'ComparisonEntity', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Aplica monto economico', property: 'AppliesEconomicValue', visible: true },
        { title: 'Valor', property: 'ComparisonAmount', visible: true },
        { title: 'Estado del comparendo', property: 'ComparisonStateName', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Adjuntos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalAdd({ ...modalAdd, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Comparendos">
            <div className="row">
                <div className="col-md-6">
                    <label>Estado</label>
                    <select className="form-control" value={state} onChange={(e: any) => { setstate(e.target.value) }} >
                        <option value={NaN}>...</option>
                        <option value={1}>ACTIVO</option>
                        <option value={2}>BORRADOR</option>
                    </select>
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={Comparison.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={Comparison.bean.IDAccount} onChange={(e) => { Comparison.setBean({ ...Comparison.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo Comparendo</label>
                                    <SelectTHConstantsValue code={203} value={Comparison.bean.TypeComparison} onChange={(e: any) => { Comparison.setBean({ ...Comparison.bean, "TypeComparison": e }) }}></SelectTHConstantsValue>
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha Comparendo" name="ComparisonDate" value={Comparison.bean.ComparisonDate} setDate={(e) => { Comparison.setBean({ ...Comparison.bean, "ComparisonDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Entidad que impone comparendo</label>
                                    <SelectTHConstantsValue code={213} value={Comparison.bean.ComparisonEntity} onChange={(e: any) => { Comparison.setBean({ ...Comparison.bean, "ComparisonEntity": e }) }}></SelectTHConstantsValue>
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Aplica monto economico ?" estado={Comparison.bean.AppliesEconomicValue} eventChange={(e: any) => {

                                        Comparison.setBean({ ...Comparison.bean, "AppliesEconomicValue": e });
                                    }} />
                                </div>
                                {Comparison.bean.AppliesEconomicValue &&
                                    <>

                                        <div className="col-md-6">
                                            <label>Valor</label>
                                            <input type='text' name="ComparisonAmount" className="form-control" value={Comparison.bean.ComparisonAmount} onChange={Comparison.handleChange} />
                                        </div>

                                    </>
                                }
                                <div className="col-md-6">
                                    <label className="form-label">Estado del comparento</label>
                                    <select className="form-control" value={Comparison.bean.ComparisonState} onChange={(e) => { Comparison.setBean({ ...Comparison.bean, 'ComparisonState': e.target.value }) }}>
                                        <option value={0}>...</option>
                                        <option value={100}>Pagado</option>
                                        <option value={101}>Pendiente</option>

                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={Comparison.bean.Description} onChange={Comparison.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>

                    <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={editaItem}>
                        <>
                            <div className="col-md-12">
                                <FileInput
                                    Media={Comparison.bean.Media}
                                    MediaContext={Comparison.bean.MediaContext}
                                    directory='comparendos'
                                    label='Cargar un archivo'
                                    // onCreate={(e) => { Comparison.setBean({ ...Comparison.bean, 'AttachFiles': e});console.log(e) }}
                                    onCreate={({ MediaContext, Media }: any) => { Comparison.setBean({ ...Comparison.bean, "AttachFiles": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                ></FileInput>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}